import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m4.583 12.083 5.833-1.667 1.667-5.833L6.25 6.25zm3.75-2.5q-.52.001-.885-.364a1.2 1.2 0 0 1-.365-.886q0-.52.365-.885t.885-.365.885.365.365.885-.365.886a1.2 1.2 0 0 1-.885.364m0 7.083a8.1 8.1 0 0 1-3.25-.656 8.4 8.4 0 0 1-2.646-1.78 8.4 8.4 0 0 1-1.78-2.647A8.1 8.1 0 0 1 0 8.333q0-1.73.656-3.25a8.4 8.4 0 0 1 1.781-2.646A8.4 8.4 0 0 1 5.083.657 8.1 8.1 0 0 1 8.333 0q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.781 2.646 8.1 8.1 0 0 1 .656 3.25 8.1 8.1 0 0 1-.656 3.25 8.4 8.4 0 0 1-1.78 2.646 8.4 8.4 0 0 1-2.647 1.781 8.1 8.1 0 0 1-3.25.656m0-1.666q2.77 0 4.72-1.948Q14.998 11.104 15 8.333q0-2.77-1.948-4.719-1.948-1.947-4.719-1.948-2.77 0-4.719 1.948-1.947 1.949-1.948 4.72t1.948 4.718T8.334 15"
    }, null, -1)
  ]))]))
}
export default { render: render }